import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'

// components
import FormButton from 'components/atoms/FormButton'
import FormTextFieldWithValidation from 'components/shared/FormTextFieldWithValidation'

const AddGuestPassForm = props => {
  const {
    camper,
    form, // via withState
    formErrors, // via withMutation
    mutationLoading, // via withMutation
    onChangeFormField, // via withEventHandlers
    onClickCancel, // via withEventHandlers
    onClickSubmit // via withEventHandlers
  } = props

  const { code } = form
  const formDisabled = mutationLoading || !code || code.length === 0

  return (
    <Card elevation={1}>
      <CardContent>
        <Box px={2}>
          <form>
            <FormTextFieldWithValidation
              label={`Guest Pass Code for ${camper.firstName}`}
              form={form}
              field='code'
              onChange={onChangeFormField}
              errors={formErrors}
            />

            <Typography mb={2} fontStyle='italic'>
              To add guest pass days to your cart, select a session and location
              above, make sure "Day Passes" is set to 0, then enter your code
              here and click "Add to Cart." Then click the "Save and Continue to
              Payment" button at the bottom of the page to continue the checkout
              process.
            </Typography>

            <Box py={2} align='center'>
              <FormButton variant='outlined' onClick={onClickCancel}>
                Cancel
              </FormButton>
              <FormButton
                variant='contained'
                color='secondary'
                disabled={formDisabled}
                onClick={onClickSubmit}
              >
                {mutationLoading ? 'Adding...' : 'Add to Cart'}
              </FormButton>
            </Box>
          </form>
        </Box>
      </CardContent>
    </Card>
  )
}

export default AddGuestPassForm
